import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  TimeInput,
  Input,
  DatePicker,
  Textarea,
  Select,
  SelectItem,
} from "@nextui-org/react";
import "./ModelForm.css";

const StudentForm = () => {
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  
    navigate("/admin/student");
  };

  return (
    <div className="main-inner-wrapper leavemenu-wrapper">
     
      <div className="px-4">
        <div className="leave-apply__wrapper p-4 bg-white dark:bg-neutral-800 border border-gray-300 dark:border-gray-500 rounded-xl">
        <h1 className="incident-report-heading ">Add Student Details</h1>
          <div className="form-container mt-8">
            <form onSubmit={handleSubmit}>
              <div>
                <div className="form-row">
                  <Input
                    variant="bordered"
                    label="Student Id"
                  />
                  <Input
                    variant="bordered"
                    label="Student Name"
                  />
                </div>
                {/* <div className="form-row">
                  <DatePicker variant="bordered" label="Date" />
                  <TimeInput variant="bordered" label="Time" />
                </div> */}
                <div className="form-row">
                  <Select
                    label="Year"
                    className="max-w-full"
                    variant="bordered"
                  >
                    <SelectItem key="one" value="one">
                      1st
                    </SelectItem>
                    <SelectItem key="two" value="two">
                      2nd
                    </SelectItem>
                    <SelectItem key="third" value="third">
                      3rd
                    </SelectItem>
                    <SelectItem key="four" value="four">
                      4th
                    </SelectItem>
                  </Select>
                  <Select
                    label="Department"
                    className="max-w-full"
                    variant="bordered"
                  >
                    <SelectItem key="cse" value="cse">
                      CSE
                    </SelectItem>
                    <SelectItem key="it" value="it">
                      IT
                    </SelectItem>
                    <SelectItem key="mech" value="mech">
                      MECH
                    </SelectItem>
                    <SelectItem key="ece" value="ece">
                      ECE
                    </SelectItem>
                    <SelectItem key="eee" value="eee">
                      EEE
                    </SelectItem>
                    <SelectItem key="aids" value="aids">
                      AIDS
                    </SelectItem>
                  </Select>
                </div>
                {/* <div className="form-row">
                  <Select
                    label="Type Of Incident"
                    className="max-w-full"
                    variant="bordered"
                  >
                    <SelectItem
                      key="Defibrillator Mishandling"
                      value="Defibrillator Mishandling"
                    >
                      Defibrillator Mishandling
                    </SelectItem>
                    <SelectItem
                      key="Medication Dosage Error"
                      value="Medication Dosage Error"
                    >
                      Medication Dosage Error
                    </SelectItem>
                    <SelectItem
                      key="Contaminated Supplies Issue"
                      value="Contaminated Supplies Issue"
                    >
                      Contaminated Supplies Issue
                    </SelectItem>
                    <SelectItem
                      key="Handoff Miscommunication"
                      value="Handoff Miscommunication"
                    >
                      Handoff Miscommunication
                    </SelectItem>
                  </Select>
                  <Input
                    variant="bordered"
                    label="Attachment"
                    type="file"
                    style={{ opacity: "0" }}
                  />
                </div> */}
                <div className="form-row">
                  <Input
                    variant="bordered"
                    label="Phone number"
                    type="number"
                  />
                  <Input
                    variant="bordered"
                    label="Email"
                  />
                </div>

                <div className="flex justify-center items-center gap-4" >
                  <Button className="incidentSubmitBtn" type="submit">
                    Submit
                  </Button>
                  <Button color="danger" variant="flat" onClick={() => navigate('/admin/student')}>
                    Cancel
                  </Button>
                </div>

              </div> </form>

          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentForm;
